var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2000 2048",
    width: 640,
    height: 640,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(693,282)",
    d: "m0 0h46l458 1 9 3 9 9 9 14 5 13 1 6v68l1 167 80-1h120l15 3 11 6 5 5 6 7 9 17 4 16 1 107v397l-1 161-1 112v275l2 13 5 2 73 1 10 1 1 9-1 36-1 2h-1125l-1-1-1-44 2-3 13-1 56-1 18-2 1-1 1-1342 2-14 4-11 6-11 12-13 8-4 11-1z",
    fill: "#045F78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(535,356)",
    d: "m0 0h1l2 18 1 10v139 3l-1 4 1 6-1 4 1 4h-1v27l1 15 1 21 1 14v30l1 5-1 9h2v-9l2-6v-8l3-7 2-11v-4h2l3 9-2 10v2l3 3-1 19v2l3 1-2 9h-2l2 10v10l-1 3 1 5 2 2-4 9h2l1 11v9l-2 11 4-1-1 4-1 1-1 16v17h2l-1 3-2-1 1 5v22l-2 12 1 5-1 10 1 25v39l2 12-1 4v-2h-2l2 4v3 7l1 2-2 7 1 5v8l-2 1 2 7-1 5 3 15v15l1 4-1 10v22l-1 26-1 6 3 1v5h-3v7l-2 5 1 2 1 16-1 5 1 25v15l-1 10h2l1 3v7l-2 8 2 18-1 16 1 10v27h-2l1 10-1 1v14l2 6h-2v11l2 1-1 3v13l-1 3h2v7h-1v28l1 1v7h-2l2 11v5l-1 1v23l1 3-2 9 1 9-2 30v7l1 7-1 9 1 9-2 12 1 2-1 9-1 6h2l-2 16h2l-1 11 1 12v3 23l1 4h-2v10h2l-1 8v7l1 1-1 8-2 4 2 4v3l-2 8v8l-6 24-5 13-2 6-2 4-5 2v-1322z",
    fill: "#045271"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1333,793)",
    d: "m0 0h15l14 7 12 11 8 11 6 12 2 6 2 11 1 13v22l-1 13-3 14-5 15-10 14-13 13-13 8-7 2-10-4-10-8-7-7-8-11-6-12-4-14-1-17v-44l3-14 8-15 8-11 10-10 6-4z",
    fill: "#FFFEFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1338,1303)",
    d: "m0 0 9 1 10 5 11 10 5 5 9 11 7 14 3 15 1 15v11l-2 23-5 19-5 12-8 12-7 8-9 6-10 4-7 1-10-3-11-8-9-10-9-17-5-17-2-19v-38l3-14 8-16 8-11 13-13z",
    fill: "#FFFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1336,1048)",
    d: "m0 0h8l9 4 10 7 12 10 9 11 6 12 3 12 1 19-1 29-4 18-6 15-7 10-10 11-13 10-8 4h-7l-8-3-11-10-11-14-8-16-4-15-1-25v-28l3-17 7-14 9-11 8-9h2l1-3z",
    fill: "#FFFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(878,453)",
    d: "m0 0 12 2 13 8 4 3v2h2l8 10 8 16 3 17v44l-1 15-4 17-8 15-11 12-14 11-6 2-9-1-11-6-11-12-7-11-4-8-5-19-2-22v-23l1-15 4-17 7-14 7-9 8-9 10-6z",
    fill: "#FFFEFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1071,454)",
    d: "m0 0h11l8 3 11 8 10 11 8 14 4 13 2 14v32l-2 22-4 17-6 11-11 13-10 9-10 5-7 1-11-4-11-10-7-10-7-14-4-17-2-36v-18l2-19 4-12 7-12 8-10 8-7z",
    fill: "#FFFEFE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(876,738)",
    d: "m0 0 11 1 8 4 11 10 5 5 8 10 7 14 2 7v60l-3 16-4 11-5 9-11 12-7 7-9 6-4 2h-7l-11-6-10-9-8-10-8-16-5-21-1-36 1-16 4-16 8-16 8-11 9-10z",
    fill: "#FFFEFE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(876,1024)",
    d: "m0 0h9l12 6 10 9 7 7 7 11 5 14 1 5v60l-4 18-5 12-7 11-11 11-8 6-6 3h-8l-12-6-10-9-9-13-5-10-5-18-1-10v-47l2-12 6-16 7-11 11-13 11-7z",
    fill: "#FFFEFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1072,1024)",
    d: "m0 0h10l12 6 11 11 10 14 7 15 3 16 1 23-1 17-4 23-5 14-7 11-7 9-11 9-9 4h-9l-12-6-9-8-9-13-6-16-2-11-1-12v-52l4-16 7-14 13-16 8-6z",
    fill: "#FFFEFE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(681,453)",
    d: "m0 0 11 1 12 7 11 11 7 10 6 12 3 12 1 8v39l-2 18-5 16-8 14-11 14-8 7-8 4-11-1-11-6-10-10-7-11-6-14-3-17-1-18v-36l2-15 5-13 7-11 9-10 8-7z",
    fill: "#FFFEFE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1072,738)",
    d: "m0 0 8 1 10 5 13 11 12 15 7 14 4 19v32l-4 26-5 15-8 12-9 10-7 7-11 6h-9l-9-4-8-7-7-8-7-11-5-13-2-9-1-15-1-30v-15l2-14 8-17 10-13 9-10 8-6z",
    fill: "#FFFEFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(683,1022)",
    d: "m0 0 9 2 11 8 8 8 9 12 7 12 4 13 1 9v41l-2 15-3 11-4 10-9 15-13 13-10 5-6 1-10-3-11-8-9-10-8-15-3-11-2-17-1-23v-17l1-19 3-10 7-12 9-11 12-13 8-5z",
    fill: "#FFFEFE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(682,737)",
    d: "m0 0 7 1 10 6 5 4 7 8 12 16 6 12 2 7 1 9v43l-3 19-4 11-10 16-11 12-8 7-6 4-8-1-10-5-10-9-6-7-8-14-4-13-1-4-1-20v-45l2-13 7-13 10-13 11-12 5-4z",
    fill: "#FFFEFE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(693,282)",
    d: "m0 0h46l458 1 9 3 9 9 9 14 3 7-1 3-3-5-4-4-8-11-4-4v-3l-6-2-3-3-28 2-25 1-19 1-34 1-26 1-22 2h-32l-81 2-46 1h-30l-11-1h-11l-6-1h-12l-16-1-28-1-18-1h-12l-23-1h-17l-60-1-44-2h-21l-17 4-7 5h-2l-2 4-2 5-4 5h-2l2-6 6-8 9-10 8-4 11-1z",
    fill: "#045271"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(666,1727)",
    d: "m0 0h114l2 1h53l4 1 171 1v1l-215 1h-155l-113-1v-1l25-1 21-1h43l6 1 29-1z",
    fill: "#045271"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1265,1727)",
    d: "m0 0h133l38 3 25 1v1h-245l4-3 13-1z",
    fill: "#045271"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1310,1323)",
    d: "m0 0h2l-2 4-8 13-5 12-2 11v38l2 19 5 17 9 17 10 11v2h-3l-7-8-5-5-7-11-6-18-3-18-1-3v-17l1-2v-16l2-7 6-25 4-8 4-1v-2z",
    fill: "#045472"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,507)",
    d: "m0 0h1l1 42 2 26 3 12 8 16 5 7v3l-4-2-5-5-6-12-5-13-4-19-1-16v-9l1-9 1-4 1-5v-7z",
    fill: "#045472"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(639,1079)",
    d: "m0 0 2 4 2 50 3 21 4 11 7 12 9 10 12 8-2 1-10-6-12-11-7-10-4-10-2-12-2-5-2-12-1-9 1-14 2-14z",
    fill: "#045372"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1561,1686)",
    d: "m0 0h8l2 3-1 41-1 2h-63v-1l36-2 20-3 2-3v-36z",
    fill: "#045271"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(541,766)",
    d: "m0 0 2 1 1 6-1 8 1 20v29l1 4-1 7 2 5h-2v12l-1 12h-2l-3-20 1-23v-34l1-7v-16-3z",
    fill: "#056079"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(836,570)",
    d: "m0 0h2l5 19 6 12 8 10 7 8-2 2-6-4v-2h-2l-8-11v-2h-2v-2l-3-1-4-10-2-8z",
    fill: "#045372"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1393,1367)",
    d: "m0 0h1v5h2l2 6-1 2h2v12l-1 4v8l-2 9-3 1v-2h-2l1-22z",
    fill: "#045372"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(733,1121)",
    d: "m0 0 4 1 3 10-1 5-3 11-6 1-1-1 1-11 2-14z",
    fill: "#045371"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1081,453)",
    d: "m0 0 6 1 10 5 10 9 7 8 4 7 5 10 3 12v13l-2-1-2-14-5-15-7-12-11-12-13-8-5-2z",
    fill: "#045472"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(886,453)",
    d: "m0 0 6 1 9 5 10 8 7 8 5 7 5 13 2 14v12h-1l-2-19v-5h-2l-5-12-7-11-4-4v-2h-2v-2l-4-2-13-8-4-2z",
    fill: "#045472"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,811)",
    d: "m0 0h1l2 28v22l-2-4-2-5-1-6v-13l-1-7 1-11z",
    fill: "#045371"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1349,793)",
    d: "m0 0 5 1 7 3v2l5 2 13 12 8 12 4 10 2 9v8l-2-1-3-14-4-10-7-11-11-12-11-7-6-3z",
    fill: "#045472"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1081,739)",
    d: "m0 0 5 1 11 7 11 10 9 11 6 13 3 10v7h-2l-3-14-7-14-13-16-11-9-9-5z",
    fill: "#045472"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1094,1030)",
    d: "m0 0 4 2 8 7 8 9 5 9 4 9 3 12v9l-2-1-3-16-8-16-7-10-9-10z",
    fill: "#045572"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1446,566)",
    d: "m0 0 6 2 9 6 8 11 7 13-1 3v-2h-2l-2-3v-3h-2l-9-12v-2l-3-1-4-4v-2l-4-2-3-2z",
    fill: "#045371"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1036,1154)",
    d: "m0 0 3 2 6 15 10 13 6 5-1 2h-3l-7-8-5-4v-2h-2l-6-12-2-5z",
    fill: "#045372"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(644,1150)",
    d: "m0 0 2 4 4 11 7 12 9 10 12 8-2 1-10-6-12-11-7-10-4-10z",
    fill: "#045673"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(836,1143)",
    d: "m0 0 3 3 6 18 9 14-1 3-6-5-6-9-4-10-2-6z",
    fill: "#045472"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1353,1306)",
    d: "m0 0 5 2 9 7 14 14 6 9 4 10v4h-2l-5-12-7-10-7-8v-2l-4-2-9-8z",
    fill: "#045573"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(693,1024)",
    d: "m0 0 5 2 11 9 7 7 9 13 5 12 1 6h-2l-5-13-10-15-12-13-9-7z",
    fill: "#045573"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(693,454)",
    d: "m0 0 6 2 10 7 11 11 7 11 4 11v5l-2-1-6-15-7-10-9-10-9-7-5-3z",
    fill: "#045472"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1360,1056)",
    d: "m0 0 5 2 10 8 10 11 5 7 3 11v5h-2l-4-13-6-10-9-10-10-8z",
    fill: "#045472"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1035,576)",
    d: "m0 0 2 2 4 13 7 14 4 5-1 3-8-8-7-12-1-11-1-5z",
    fill: "#045472"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(895,743)",
    d: "m0 0 5 2 13 12 9 11 6 12 1 7-2-2v-3h-2l-7-14-8-10-5-5-10-9z",
    fill: "#045572"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(702,746)",
    d: "m0 0 4 2 12 12 8 13 4 9 1 5h-2l-4-10-7-11-9-11-2-4-3-1v-2h-2z",
    fill: "#045572"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1037,870)",
    d: "m0 0 2 1 5 12 10 14 2 4-8-6-1-3-3-1-4-5-4-11z",
    fill: "#045572"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1292,863)",
    d: "m0 0h1l3 29v18h-1l-4-22z",
    fill: "#045371"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(839,866)",
    d: "m0 0 2 2 5 12 7 11 1 4-4-2-7-8-4-11z",
    fill: "#045472"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1031,1107)",
    d: "m0 0 2 1v25l-4-4v-14z",
    fill: "#045271"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(900,1032)",
    d: "m0 0 4 2 8 7 6 7 7 12-1 3-3-3-5-10-11-12z",
    fill: "#045472"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1031,533)",
    d: "m0 0h1l1 6v20l-2-1-2-5v-13z",
    fill: "#045271"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1299,1178)",
    d: "m0 0 1 2h2l5 10 3 7v3l-6-7-5-9z",
    fill: "#045472"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1299,923)",
    d: "m0 0h2l7 14 2 2-1 4-1-3-4-2-5-9z",
    fill: "#045673"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(444,1684)",
    d: "m0 0h24v1l-14 1-7 2-2 6-2-3-1-4z",
    fill: "#045271"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(644,867)",
    d: "m0 0h2l4 11 3 9 2 4h-2l-4-5-4-10-2-6z",
    fill: "#045573"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1047,760)",
    d: "m0 0 1 3-6 9-4 8h-2l1-5 4-9 1-2h3v-2h2z",
    fill: "#045572"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1123,568)",
    d: "m0 0h3l1 10-1 2h-2l-1 3-2-4z",
    fill: "#045371"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1124,1138)",
    d: "m0 0 3 1v9l-5 4-1-4 1-6z",
    fill: "#045271"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(732,549)",
    d: "m0 0h2v2h2l1 3v7l-4 4z",
    fill: "#045271"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(657,757)",
    d: "m0 0h2l-2 4-9 14-3 3v-3l5-10 5-5z",
    fill: "#045472"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1122,497)",
    d: "m0 0 2 1 2 7v13l-2-1-2-14z",
    fill: "#045773"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1322,1468)",
    d: "m0 0 5 1 8 4 8 2v1h-9l-11-6z",
    fill: "#045573"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(444,1727)",
    d: "m0 0h2l1 2 26 1v1h-30z",
    fill: "#045271"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1120,779)",
    d: "m0 0h2l4 12v7h-2l-3-14z",
    fill: "#045774"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(654,1047)",
    d: "m0 0 1 2-8 13-3 3 2-6 3-7z",
    fill: "#045572"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(640,507)",
    d: "m0 0h1v12h-3v-7z",
    fill: "#045271"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.05ebcde4635cd7fec473559f4f6f23e8.svg";
export { ForwardRef as ReactComponent };